<script setup lang="ts">
import {
  bool, func, object,
} from 'vue-types';

import useFileAiPromptsSearch from './useFileAiPromptsSearch';
import FileAiPromptsBaseTable from './FileAiPromptsBaseTable.vue';

import NoDataUrql from '@/ui/NoDataUrql/NoDataUrql.vue';
import Skeletons from '@/ui/Skeletons.vue';
import type {
  FileAiPromptFragmentFragment,
  FileAiPromptsQueryVariables,
} from '@/graphql/generated/graphql';

const props = defineProps({
  getLink: func<(data: FileAiPromptFragmentFragment) => string>(),
  onClick: func<(data: FileAiPromptFragmentFragment) => void>(),
  onSelect: func<(data: FileAiPromptFragmentFragment) => void>(),
  setUrl: bool(),
  forceFilters: object<FileAiPromptsQueryVariables>(),
});

const forceFiltersComputed = computed(() => props.forceFilters);
const search = useFileAiPromptsSearch(props.setUrl, forceFiltersComputed);
</script>

<template>
  <NoDataUrql
    v-if="!search.data?.value?.data"
    :error="search.error.value"
    :fetching="search.fetching.value"
  >
    <Skeletons :total="10" :avatar="false" :paragraph="false" />
  </NoDataUrql>
  <FileAiPromptsBaseTable
    v-if="search.data?.value?.data"
    :pagination="search.data.value.paginatorInfo"
    :data-source="search.data.value.data"
    :loading="search.fetching.value"
    :set-query="search.setQuery"
    :search="search.search.value"
    :set-search="search.setSearch"
    :query="search.query.value"
    :variables="search.variables"
    :refetch="search.refetch"
    :get-link="getLink"
    :on-click="onClick"
    :on-select="onSelect"
  />
</template>
